__turbopack_context__.v({
  "box": "fields-module___ZMXkW__box",
  "check": "fields-module___ZMXkW__check",
  "chip": "fields-module___ZMXkW__chip",
  "chips": "fields-module___ZMXkW__chips",
  "error": "fields-module___ZMXkW__error",
  "field": "fields-module___ZMXkW__field",
  "hint": "fields-module___ZMXkW__hint",
  "input": "fields-module___ZMXkW__input",
  "label": "fields-module___ZMXkW__label",
  "optional": "fields-module___ZMXkW__optional",
  "prefix": "fields-module___ZMXkW__prefix",
  "signature": "fields-module___ZMXkW__signature",
  "slotGroup": "fields-module___ZMXkW__slotGroup",
  "slots": "fields-module___ZMXkW__slots",
  "textarea": "fields-module___ZMXkW__textarea",
  "well": "fields-module___ZMXkW__well",
});
